import { render, staticRenderFns } from "./taobao_shangou_gzh.vue?vue&type=template&id=2166b3cb&scoped=true&"
import script from "./taobao_shangou_gzh.vue?vue&type=script&lang=js&"
export * from "./taobao_shangou_gzh.vue?vue&type=script&lang=js&"
import style0 from "./taobao_shangou_gzh.vue?vue&type=style&index=0&id=2166b3cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2166b3cb",
  null
  
)

export default component.exports